module.exports = __webpack_public_path__ + "c414f4d6c7867490fd39e90dbd306027.pdf";